import { RESPONSE_CODES } from "@simplyhealth/iam_client_lib";
import {
  sorryUnableTo,
  DEFAULT_PROBLEM_TITLE,
  CONTINUE_DIFFICULTIES_MESSAGE,
  TRY_AGAIN_LATER_MESSAGE,
  TECH_GLITCH_MESSAGE
} from "../../../helpers/constants";

export function createUIMessageAndTitleFromResponseCodes(code: string = "", supportCode?: string): [string[], string] {
  const messages = new Array<string>();
  let title = DEFAULT_PROBLEM_TITLE;
  const lowercaseCode = code.toLowerCase();

  switch (lowercaseCode) {
    case RESPONSE_CODES.Verification_ExpiredCodeException.toLowerCase():
      messages.push("The code to confirm your account has expired.");
      break;
    case RESPONSE_CODES.Verification_CodeMismatchException.toLowerCase():
      messages.push(sorryUnableTo("complete your request"), TRY_AGAIN_LATER_MESSAGE, CONTINUE_DIFFICULTIES_MESSAGE);
      break;
    default:
      messages.push(sorryUnableTo("complete your request"), TECH_GLITCH_MESSAGE, TRY_AGAIN_LATER_MESSAGE);
  }

  return [messages, title];
}
